module.exports = __webpack_public_path__ + "components/rewards/hike-and-ride/static/logo-c64822283ec5cdad85917d1f653861b7.webp";